import React, { useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { Header } from "../components/Sidebar";
import { useAuth } from "../context/AuthContext";
import api, { apiErr } from "../lib/api";
import { ROLE_LABELS } from "../lib/format";
import { UserRound, Save, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../components/ui/alert-dialog";

const input = "w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-[#3B82F6] focus:ring-2 focus:ring-blue-100";

export default function MiPerfil() {
  const { setMobileOpen } = useOutletContext();
  const { user, setUser, logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: user?.name || "", whatsapp: user?.whatsapp || "", password: "" });
  const [loading, setLoading] = useState(false);
  const [confirmDel, setConfirmDel] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.put("/auth/me", { name: form.name, whatsapp: form.whatsapp, ...(form.password ? { password: form.password } : {}) });
      setUser(data); setForm((f) => ({ ...f, password: "" })); toast.success("Perfil actualizado");
    } catch (e2) { toast.error(apiErr(e2)); }
    finally { setLoading(false); }
  };

  const delAccount = async () => {
    try { await api.delete("/auth/me"); toast.success("Cuenta eliminada"); localStorage.removeItem("pya_token"); navigate("/login"); window.location.reload(); }
    catch (e2) { toast.error(apiErr(e2)); }
  };

  return (
    <>
      <Header title="Mi perfil" subtitle="Tus datos de cuenta" onMenu={() => setMobileOpen(true)} />
      <main className="p-4 sm:p-6 lg:p-8 max-w-2xl space-y-5">
        <div className="bg-white rounded-xl border border-[#E2E8F0] p-6 shadow-sm">
          <div className="flex items-center gap-4 pb-4 border-b border-slate-100">
            <div className="h-14 w-14 rounded-full bg-[#3B82F6] text-white flex items-center justify-center font-bold text-xl">{(user?.name || "U").charAt(0).toUpperCase()}</div>
            <div>
              <div className="font-bold text-lg text-[#0A1F44]">{user?.name}</div>
              <div className="text-sm text-[#64748B]">{user?.email}</div>
              <span className="inline-block mt-1 text-xs font-semibold px-2.5 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-100">{ROLE_LABELS[user?.role]}</span>
            </div>
          </div>
          <form onSubmit={save} className="mt-5 space-y-3">
            <div><label className="text-xs font-semibold text-[#64748B]">Nombre</label><input className={input} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="perfil-name-input" /></div>
            <div><label className="text-xs font-semibold text-[#64748B]">WhatsApp</label><input className={input} value={form.whatsapp} onChange={(e) => setForm({ ...form, whatsapp: e.target.value })} /></div>
            <div><label className="text-xs font-semibold text-[#64748B]">Nueva contraseña (opcional)</label><input type="password" className={input} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Dejar vacío para no cambiar" /></div>
            <button disabled={loading} data-testid="perfil-save-btn" className="w-full flex items-center justify-center gap-2 rounded-lg bg-[#0A1F44] hover:bg-[#132D5C] text-white font-semibold py-2.5 text-sm disabled:opacity-60"><Save className="h-4 w-4" /> {loading ? "Guardando..." : "Guardar cambios"}</button>
          </form>
        </div>

        <div className="bg-white rounded-xl border border-rose-200 p-6 shadow-sm">
          <h3 className="font-bold text-rose-700">Zona de riesgo</h3>
          <p className="text-sm text-[#64748B] mt-1">Eliminar tu cuenta es permanente y no se puede deshacer.</p>
          <button onClick={() => setConfirmDel(true)} data-testid="perfil-delete-btn" className="mt-3 flex items-center gap-2 text-sm font-semibold text-rose-600 border border-rose-300 hover:bg-rose-50 rounded-lg px-4 py-2"><Trash2 className="h-4 w-4" /> Eliminar mi cuenta</button>
        </div>
      </main>

      <AlertDialog open={confirmDel} onOpenChange={setConfirmDel}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>¿Eliminar tu cuenta?</AlertDialogTitle>
            <AlertDialogDescription>Esta acción eliminará <b>{user?.email}</b> de forma permanente y no se puede deshacer.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={delAccount} className="bg-rose-600 hover:bg-rose-700" data-testid="perfil-confirm-delete">Sí, eliminar</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
